import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {FicheIntervention} from 'app/models/ficheIntervention.model';
import {FicheInterventionService} from 'app/services/fiche-intervention.service';
import {HttpErrorResponse} from '@angular/common/http';
import {Router} from '@angular/router';
import {DebrisTypeEquipement} from 'app/models/debrisTypeEquipement.model';
import {DebrisTypeEquipementService} from 'app/services/debris-type-equipement.service';
import {
    ModalFormDebrisTypeEquipementComponent
} from './modal-form-debris-type-equipement/modal-form-debris-type-equipement.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'app-form-fiche-intervention',
    templateUrl: './form-fiche-intervention.component.html',
    styleUrls: ['./form-fiche-intervention.component.scss']
})
export class FormFicheInterventionComponent implements OnInit {
    @Input() currentFicheIntervention: FicheIntervention = new FicheIntervention();
    @Input() idDossierIntervention: number;
    @Output() onValueChanged = new EventEmitter();
    @Output() onSaveNewFiche = new EventEmitter();
    success: boolean = false;
    error: boolean = false;
    tabIndex: number = 0;

    debrisTypesEquipements: DebrisTypeEquipement[];

    ficheInterventionForm: FormGroup;

    constructor(private ficheInterventionService: FicheInterventionService, private debrisTypeEquipementService: DebrisTypeEquipementService, public dialog: MatDialog, private router: Router) {
    }

    ngOnInit(): void {
        this.initForm();
        this.getDebrisTypesEquipements();

        this.ficheInterventionForm.valueChanges.subscribe(() => {
            this.onValueChanged.emit(true);
        });
    }

    initForm() {
        this.ficheInterventionForm = new FormGroup({
            id: new FormControl(this.currentFicheIntervention.id ? this.currentFicheIntervention.id : null),
            dossier_intervention_id: new FormControl(this.idDossierIntervention),
            date_contact: new FormControl(this.currentFicheIntervention.date_contact, [Validators.required]),
            date_intervention: new FormControl(this.currentFicheIntervention.date_intervention),
            categorie_intervention: new FormControl(this.currentFicheIntervention.categorie_intervention),
            contenu_rapporte_urgex: new FormControl(this.currentFicheIntervention.contenu_rapporte_urgex),
            travaux_a_effectuer: new FormControl(this.currentFicheIntervention.travaux_a_effectuer),
            cause_sinistre: new FormControl(this.currentFicheIntervention.cause_sinistre),
            recommendation: new FormControl(this.currentFicheIntervention.recommendation),
            camion_usine: new FormControl(this.currentFicheIntervention.camion_usine),
            debris_type_equipement_id: new FormControl(this.currentFicheIntervention.debris_type_equipement_id != null ? Number(this.currentFicheIntervention.debris_type_equipement_id) : null),
            debris_quantite: new FormControl(this.currentFicheIntervention.debris_quantite),
            sacs_ordure: new FormControl(this.currentFicheIntervention.sacs_ordure),
            eau_aspire: new FormControl(this.currentFicheIntervention.eau_aspire),
            pompe_submersible: new FormControl(this.currentFicheIntervention.pompe_submersible),
            nettoyage: new FormControl(this.currentFicheIntervention.nettoyage),
            tyvek: new FormControl(this.currentFicheIntervention.tyvek),
            mask: new FormControl(this.currentFicheIntervention.mask),
            tapis_de_protection: new FormControl(this.currentFicheIntervention.tapis_de_protection),
            couverture: new FormControl(this.currentFicheIntervention.couverture),
            polythene: new FormControl(this.currentFicheIntervention.polythene),
            protection: new FormControl(this.currentFicheIntervention.protection),
            hauteur: new FormControl(this.currentFicheIntervention.hauteur),
            largeur: new FormControl(this.currentFicheIntervention.largeur),
            restriction_zone: new FormControl(this.currentFicheIntervention.restriction_zone)
        });
    }

    getDebrisTypesEquipements(): void {
        this.debrisTypeEquipementService.getDebrisTypesEquipements().subscribe((debrisTypesEquipements) => {
            this.debrisTypesEquipements = debrisTypesEquipements;
        });
    }

    onFormSubmit(): void {
        this.error = false;
        this.success = false;
        this.ficheInterventionForm.markAllAsTouched();

        if (this.ficheInterventionForm.valid) {
            const ficheIntervention = new FicheIntervention(this.ficheInterventionForm.value);
            if (ficheIntervention.id === null) {
                this.ficheInterventionService.store(ficheIntervention).subscribe(
                    (response) => {
                        this.success = true;
                        this.onValueChanged.emit(false);
                        this.router.navigate(['/dossiers-interventions/', this.idDossierIntervention, 'fiches-interventions', response['id']], { replaceUrl: true });
                        this.onSaveNewFiche.emit(true);
                    }, (error) => {
                        this.error = true;
                    }
                );
            } else {
                this.ficheInterventionService.update(ficheIntervention, this.currentFicheIntervention.id).subscribe(
                    (response) => {
                        this.success = true;
                        this.onValueChanged.emit(false);
                    }, (error) => {
                        this.error = true;
                    }
                );
            }
        }
    }

    ajouterDebrisTypeEquipement(): void {
        event.stopPropagation();
        const dialogRef = this.dialog.open(ModalFormDebrisTypeEquipementComponent, {
            width: window.innerWidth <= 1024 ? '100%' : '35%',
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result != undefined) {
                this.getDebrisTypesEquipements();
                this.ficheInterventionForm.patchValue({
                    debris_type_equipement_id: result.id != null ? +result.id : null
                });
            }
        });
    }

    get isPolytheneFilled() {
        return this.ficheInterventionForm.get('polythene')?.value;
    }
}
